var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83337 5.5L8.17031 9.09056C10.5065 10.4143 11.4936 10.4143 13.8298 9.09056L20.1667 5.5",
    stroke: "#626262",
    strokeWidth: 1.375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84783 12.3528C1.90775 15.1629 1.93772 16.5679 2.97458 17.6087C4.01145 18.6495 5.45451 18.6858 8.34063 18.7583C10.1194 18.803 11.8807 18.803 13.6595 18.7583C16.5456 18.6858 17.9886 18.6495 19.0255 17.6087C20.0624 16.5679 20.0923 15.1629 20.1523 12.3528C20.1715 11.4493 20.1715 10.5511 20.1523 9.64752C20.0923 6.83745 20.0624 5.43242 19.0255 4.3916C17.9886 3.35079 16.5456 3.31453 13.6595 3.24202C11.8807 3.19732 10.1194 3.19732 8.34063 3.24201C5.45451 3.31452 4.01145 3.35078 2.97458 4.39159C1.93771 5.4324 1.90775 6.83744 1.84782 9.64751C1.82856 10.5511 1.82856 11.4493 1.84783 12.3528Z",
    stroke: "#626262",
    strokeWidth: 1.375,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.700e5d8e79d893551e2c656ac350fb4e.svg";
export { ForwardRef as ReactComponent };